import { useState } from 'react';

import { Button, Form } from 'antd';
import { AuthUseCaseInterface } from 'application/usecases/AuthUseCase';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { PasswordFormItem } from './components/Password';

interface props {
    authUseCase: AuthUseCaseInterface;
}

const CU02501Page = ({ authUseCase }: props) => {
    const dispatch = useAppDispatch();
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [errMessage, setErrMessage] = useState<string>();
    const [errMessageNew, setErrMessageNew] = useState<string>();
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const submit = async (value: any) => {
        try {
            const payload = {
                oldPassword: value.oldPassword,
                newPassword: value.newPassword,
            };
            dispatch(startFetching());
            const response = await authUseCase.changePassword(payload);
            if (response?.result) {
                openSuccessNoti({ description: getMessage('I0138') });
                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_003_01}`);
            }
        } catch (error: any) {
            if (error?.result?.message) {
                if(error.result.errorCode === 'E0700') {
                    setErrMessage(error?.result?.message);
                } else {
                    setErrMessageNew(error?.result?.message);
                }
            } else {
                openErrorNoti();
            }
        } finally {
            dispatch(completeFetching());
        }
    };

    const onChangeForm = () => {
        setErrMessage('');
        setErrMessageNew('');
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setIsDisabled(false);
            })
            .catch((err) => {
                setIsDisabled(err.errorFields.length > 0);
            });
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-025-01-container"
        >
            <PageTitle title="パスワード変更" />
            <section
                style={{
                    width: '100%',
                    height: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    borderRight: '1px solid #192F51',
                    borderLeft: '1px solid #192F51',
                }}
                className="center-inside"
            >
                <Form onFinish={submit} form={form} onValuesChange={onChangeForm}>
                    <div style={{ width: 343 }}>
                        <PasswordFormItem name="oldPassword" label="現在のパスワード" 
                            errorMessage={errMessage}
                            isDisplayNote={true}/>
                        <PasswordFormItem
                            name="newPassword"
                            label="変更後のパスワード"
                            errorMessage={errMessageNew}
                            isDisplayNote={true}
                        />
                        <Button
                            className="button-login-text"
                            type="primary"
                            style={{ width: '100%', height: 56, marginTop: 16, fontSize: 16 }}
                            disabled={isDisabled}
                            htmlType="submit"
                        >
                            再設定
                        </Button>
                    </div>
                </Form>
            </section>
        </div>
    );
};
export default CU02501Page;
